import React from 'react';
import PropTypes from 'prop-types';
import { MetadataPropTypesShape } from '@Components/Results/MetadataPropTypes';
import PatentContent from '@Containers/PatentFamilyClustering/Components/PatentContent';

import './SinglePatentFromFamily.scss';

function SinglePatentFromFamily({ document, metadata, zoom, viewFullPatentFamily, getTrackingAttrs }) {
  return (
    <section className="single-patent-from-family u-els-padding-top">
      <PatentContent
        document={document}
        metadata={metadata}
        zoom={zoom}
        isSinglePatent
        getTrackingAttrs={getTrackingAttrs}
        viewFullPatentFamily={viewFullPatentFamily}
      />
    </section>
  );
}

SinglePatentFromFamily.propTypes = {
  // Own props
  metadata: MetadataPropTypesShape,
  document: PropTypes.object.isRequired,
  zoom: PropTypes.number,
  // Selectors / Actions
  viewFullPatentFamily: PropTypes.func.isRequired,
  // From parent
  getTrackingAttrs: PropTypes.func.isRequired,
};

export default SinglePatentFromFamily;
